import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit, OnDestroy {

  // [imageID]="fields.banner_id"
  // [imageAR]="fields.banner_ar"

  fields = {
    banner_text: 'Privacy Policy',
    // banner_button_text: 'Request a Quote',
    // banner_button_path: '/privacy',
    banner_src: 'https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/v1710291303/banner-dress-bottom_bsdrmg.webp',
    banner_id: 'banner-dress-bottom_bsdrmg',
    banner_ar: 2
  }

  constructor(
    private cdr: ChangeDetectorRef
  ){}

  ngOnInit(): void {
    // this.initForm()

    // console.log('clean', this.services.find(svc => svc.slug == 'clean'))
  }


  ngOnDestroy(): void {
  }


  // handleSubmit(evt: any) {
  //   console.log('handleSubmit (PAGE)', evt )
  //   return firstValueFrom(this.orderService.create(evt)).then(res => {
  //     console.log('RES', res)
  //   })
  // }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}
